import { PaletteOptions } from '@mui/material/styles';

export const getAppPalette = (darkMode: boolean): PaletteOptions => ({
  mode: darkMode ? 'dark' : 'light',
  primary: {
    light: '#FF8330',
    main: '#EC5E00',
    dark: '#D94D01',
  },
  secondary: {
    light: '#42a5f5',
    main: '#1976d2',
    dark: '#1565c0',
  },
  background: {
    default: darkMode ? '#222' : '#EFF0F4',
    paper: darkMode ? '#111' : '#ffffff',
  },
});
